import { useCallback, useReducer, useRef } from "react";
import {
  initialState,
  reducer,
  reset as resetAction,
} from "../domain/mediaUpload";
import { uploadMedia } from "../services/mediaUpload";
import useMediaUploadProgress from "./useMediaUploadProgress";

// For surfaces running a single upload at a time; concurrent uploads call
// `uploadMedia` directly and keep their own state.
const useMediaUpload = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const activeRef = useRef(null);

  useMediaUploadProgress({
    mediaUploadId: state.mediaUploadId,
    state,
    onAction: dispatch,
  });

  const upload = useCallback(async (file, options = {}) => {
    const active = uploadMedia(file, options, { onEvent: dispatch });
    activeRef.current = active;

    try {
      return await active.promise;
    } finally {
      activeRef.current = null;
    }
  }, []);

  const cancel = useCallback(() => {
    activeRef.current?.cancel();
    activeRef.current = null;
    dispatch(resetAction());
  }, []);

  const reset = useCallback(() => {
    dispatch(resetAction());
  }, []);

  return { upload, state, cancel, reset };
};

export default useMediaUpload;
